<template>
  <div class="container-fluid dark-gray mt-5 pt-5 pb-5">
    <div class="row">
      <div class="col-12 text-center">
        <span><a class="footer" href="/">Proetica.org.pe</a></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>